<template>
    <modal
        transition="slide"
        :name="name"
        height="auto"
        width="100%"
        :scrollable="true"
        :click-to-close="false"
    >
        <div
            class="Modal__inner"
            :class="{'Modal__inner--closable' : closable}"
        >
            <!-- prettier-ignore -->
            <button
                v-if="closable"
                class="Modal__close"
                aria-label="Close modal"
                @click="close"
            >
                <svg height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
                </svg>
            </button>
            <slot />
        </div>
    </modal>
</template>

<script>
import 'vue-js-modal/dist/styles.css';

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        closable: {
            type: Boolean,
            default: true
        },
        variant: {
            type: [String, Boolean],
            default: false
        },
        closeIconVariant: {
            type: [String, Boolean],
            default: false
        }
    },

    methods: {
        close() {
            this.$modal.hide(this.name);
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
::v-deep .Modal__inner {
    position: relative;
    padding: 50px 30px;
    margin: 0 20px;
    background-color: #fff;

    @screen sm {
        padding: 70px 50px;
    }
}

::v-deep .Modal__inner--closable {
    padding-top: 80px;

    @screen sm {
        padding-top: 100px;
    }
}

 ::v-deep .Modal__close {
    position: absolute;
    right: 0;
    margin-right: 30px;
    top: 0;
    margin-top: 30px;
    cursor: pointer;
    color: #535353;
    background-color: transparent;
    border: none;
}

 ::v-deep .Modal__close svg {
     height: 25px;
     width: 25px;
 }

/* purgecss start ignore */
::v-deep .vm--modal  {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 80px !important;
    box-shadow: none;
}

::v-deep .vm--modal-box {
    top: 0;
    box-shadow: none;
}

.vm--modal-overlay {
    z-index: 40;
    background-color: rgba(0, 0, 0, 0.5);
}
/* purgecss end ignore */
</style>